import { render, staticRenderFns } from "./CharacterSheetProficienciesLanguages.vue?vue&type=template&id=1f0e6d1c&lang=pug&"
import script from "./CharacterSheetProficienciesLanguages.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetProficienciesLanguages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSpacer,VTextField})
